module.exports = __webpack_public_path__ + "img/example11.fd89ca97.jpg";